import React, { forwardRef } from 'react'
import { Input as MuiInput, InputOwnerState, InputOwnProps } from '@mui/base/Input'
import clsx from 'clsx'
import { inputClasses } from '@/components/ui/Input'
import { ReactComponent as EditIcon } from '@/assets/icons/edit.svg'
import classes from './TitleInput.module.scss'
import Typography from '@/components/ui/Typography'
import { useEdit } from '@/components/ui/TitleInput/TitleInput.hooks'

export type TitleInputProps = {
  value?: string
  onSave?: (value: string) => void
} & InputOwnProps

const TitleInput = forwardRef<HTMLDivElement, TitleInputProps>(function CustomInput(
  { onSave, value = '', ...props },
  ref
) {
  const edit = useEdit(value, onSave)

  const endAdornment = (
    <div
      role="presentation"
      className={clsx(classes.button, edit.isEnabled ? classes.enabled : classes.disabled)}
      onClick={edit.onSave}
      onMouseDown={edit.onSaveMouseDown}
    >
      <EditIcon />
      {/*{edit.isEnabled && <Typography isBold>Save</Typography>}*/}
    </div>
  )

  const slotProps = {
    root: (ownerProps: InputOwnerState) => ({
      className: clsx(inputClasses.root, classes.root, {
        [inputClasses.focused]: ownerProps.focused,
        [inputClasses.disabled]: ownerProps.disabled,
        [classes.focused]: ownerProps.focused,
      }),
    }),
    input: () => ({
      className: clsx(inputClasses.input, classes.input),
      ref: edit.inputRef,
    }),
  }
  return (
    <MuiInput
      slotProps={slotProps}
      {...props}
      ref={ref}
      endAdornment={endAdornment}
      onFocus={edit.onFocus}
      onBlur={edit.onBlur}
      onChange={edit.onChange}
      value={edit.value}
    />
  )
})

export default TitleInput
